import { ModalBottomComponent } from './modal-bottom.component';

export default angular
  .module('sfMobile.components.modal-bottom', [])
  .component('sfModalBottom', ModalBottomComponent).name;
